( function ( $ ) {

	MP.headerOnScroll = function(){

		const $body = $('body');

		function toggleBodyClassOnHeaderScroll(){
			if ( window.pageYOffset > lib.offset('#wpadminbar') ){
				$body.addClass('is-sticky-header');
			} else {
				$body.removeClass('is-sticky-header');
			}
		}
		toggleBodyClassOnHeaderScroll();
		window.addEventListener('scroll',toggleBodyClassOnHeaderScroll);
	};

	MP.toggleSearch = function(){

		$('#toggle_top_search').on('click', function(){

			$('#site_search').toggleClass('is-shown');

		});

	};

	MP.a11y_btn = function(){

		$('#toggle_a11y_menu').on('click', function(){
			
			$('.iAccessibility-menu-button').trigger('click');
			
			$('#iAccessibility-menu').css({
				top : this.getBoundingClientRect().bottom + 30 + 'px'
			});
			console.log(this.getBoundingClientRect().bottom + '30' + 'px');
			
		});

	};

}) ( window.jQuery);


(function($, window, document, _undefined){
	$(document).ready(function(){
		
		thisthing = $("[href^='tel:']");
		thisthing.click(function(){
			gtag('event', 'click', {'event_category': 'phonecall','event_label': 'c2c', 'value' : thisthing.html()});
		});

	});
		
})(jQuery, this, document);



// WEBPACK FOOTER //
// ./assets/js/l-header.js